import creatorNotificationApiClient from 'js/api_clients/creator_notification_api_client';
import {ENUMS} from 'js/common';

const {PostState} = ENUMS;

/**
 * @export
 * @param {string} postState
 * @return {*}
 */
export function mapPostStateToCreatorContentNotifier(postState) {
    switch (postState) {
        case PostState.WAITING_FOR_POST:
            return creatorNotificationApiClient.notifyCreatorToPost;
        case PostState.ADMIN_REJECTED_CONTENT:
            return creatorNotificationApiClient.notifyCreatorContentRejected;
        case PostState.BRAND_REJECTED_CONTENT:
            return creatorNotificationApiClient.notifyCreatorContentRejected;
        case PostState.DO_NOT_DISTRIBUTE:
            return creatorNotificationApiClient.notifyCreatorDoNotDistribute;
        default:
            return async function noop() {
                return {};
            };
    }
}



// WEBPACK FOOTER //
// ./api_reducers/creator_notifications.js